import { Component } from "@angular/core";
var HTML_TEMPLATE = "\n<div class=\"od-box-container\">\n  <div class=\"od-box-container-box\">\n    <ng-content select=\"[header]\"></ng-content>\n    <ng-content select=\"[body]\"></ng-content>\n    <ng-content select=\"[footer]\"></ng-content>\n  </div>\n</div>";
var CSS_STYLE = "\n.od-box-container {\n  width: 100%;\n  height: 100%;\n  background-color: #eff3f6;\n  padding-top: 30px;\n  z-index: 1000;\n}\n\n.od-box-container-box {\n  width: 400px;\n  font-size: 14px;\n  font-weight: 600;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: auto;\n}\n";
var BoxContainer = /** @class */ (function () {
    function BoxContainer() {
    }
    BoxContainer.decorators = [
        { type: Component, args: [{
                    selector: "od-box-container",
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    BoxContainer.ctorParameters = function () { return []; };
    return BoxContainer;
}());
export { BoxContainer };
//# sourceMappingURL=box-container.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/container/box-container.js
// module id = 446
// module chunks = 14